export default "__VITE_ASSET__B5NKnHcT__"